module.exports = __webpack_public_path__ + "static/media/privacyPolicy.6876331e.pdf";